import Immutable from 'immutable'
import { SET_DEVICE2API_LEVEL_MAP, SET_DEVICE2NAME_MAP, SET_SUPPORT_DEVICES } from '../actionTypes'

const initialState: any = Immutable.fromJS({
  supportDevices: [],
  device2apiLevelMap: {},
  device2nameMap: {},
})

const reducer = (state = initialState, action: any) => {
  const { type, data } = action

  switch (type) {
    case SET_SUPPORT_DEVICES:
      return state.set('supportDevices', data)
    case SET_DEVICE2API_LEVEL_MAP:
      return state.set('device2apiLevelMap', data)
    case SET_DEVICE2NAME_MAP:
      return state.set('device2nameMap', data)
    default:
      return state
  }
}

export default reducer
